import {
  DashboardLogsWidgets as logsWidgets,
  DashboardOperationalWidgets as operationalWidgets,
  DashboardByproductWidgets as byproductWidgets,
  DashboardByproductOperationalWidgets as byproductOperationalWidgets
} from '@/components/dashboard/WidgetMappings'

export default class IncludeHeadersForWidget {
  constructor (widget) {
    this.widget = widget

    this.AllWeight = [logsWidgets.DefectsByAccount, logsWidgets.CompletedLoadsByLogger].includes(this.widget)

    this.NetWeight = [
      logsWidgets.TransferLoads,
      logsWidgets.LogQualityAnalysis,
      logsWidgets.CompletedLoadsByLandOwner,
      logsWidgets.CompletedLoadsByDestination,
      logsWidgets.CompletedLoadsByTract,
      logsWidgets.CompletedLoadsByAccount,
      logsWidgets.CompletedLoadsByProduct,
      logsWidgets.CompletedLoadsByRegion,
      logsWidgets.CompletedLoadsByTractType,
      logsWidgets.TonsByCertification,
      byproductWidgets.CompletedLoadsByDestination,
      byproductWidgets.CompletedLoadsByProduct,
      byproductWidgets.CompletedLoadsByAccount,
      byproductWidgets.LoadsByDriver,
      logsWidgets.LoadsByDriver
    ].includes(this.widget)

    this.DefectWeight = [logsWidgets.ItemizedDefectSummary].includes(this.widget)

    this.DepartureWeight = [
      byproductWidgets.CompletedLoadsByAccount,
      byproductWidgets.CreatedLoadsByAccount
    ].includes(this.widget)

    this.Ext = ![
      logsWidgets.ItemizedDefectSummary,
      operationalWidgets.LoadsInTransitByDestination,
      logsWidgets.LogQualityAnalysis,
      logsWidgets.CompletedLoadsByLandOwner
    ].includes(this.widget)

    this.Destination = ![logsWidgets.ItemizedDefectSummary].includes(this.widget)

    this.Driver = [
      operationalWidgets.LoadsInTransitByDestination,
      operationalWidgets.IncompleteTickets,
      operationalWidgets.LoadsReadyForPickup,
      byproductOperationalWidgets.LoadsReadyForPickup,
      byproductOperationalWidgets.LoadsInTransitByDestination,
      byproductOperationalWidgets.IncompleteTickets,
      logsWidgets.LoadsByDriver,
      byproductWidgets.LoadsByDriver
    ].includes(this.widget)

    this.AllowHideDriver = ![operationalWidgets.IncompleteTickets, operationalWidgets.LoadsReadyForPickup, byproductOperationalWidgets.LoadsReadyForPickup, byproductOperationalWidgets.IncompleteTickets].includes(widget)

    this.Account = ![
      operationalWidgets.LoadsInTransitByDestination,
      byproductOperationalWidgets.LoadsInTransitByDestination,
      logsWidgets.LogQualityAnalysis,
      logsWidgets.CompletedLoadsByLandOwner
    ].includes(this.widget)

    this.Quality = [logsWidgets.LogQualityAnalysis].includes(this.widget)

    this.Logger = ![
      logsWidgets.TransferLoads,
      logsWidgets.LogQualityAnalysis,
      logsWidgets.CompletedLoadsByLandOwner,
      byproductWidgets.CompletedLoadsByDestination,
      byproductWidgets.CompletedLoadsByProduct,
      byproductWidgets.CompletedLoadsByAccount,
      byproductWidgets.CreatedLoadsByDestination,
      byproductWidgets.CreatedLoadsByProduct,
      byproductWidgets.CreatedLoadsByAccount,
      byproductWidgets.LoadsByDriver,
      logsWidgets.LoadsByDriver,
      byproductOperationalWidgets.LoadsReadyForPickup,
      byproductOperationalWidgets.LoadsInTransitByDestination,
      byproductOperationalWidgets.IncompleteTickets
    ].includes(this.widget)

    this.TractType = [logsWidgets.CreatedLoadsByTractType].includes(this.widget)

    this.Landowner = [logsWidgets.CompletedLoadsByLandOwner].includes(this.widget)

    this.Tract = ![
      logsWidgets.TransferLoads,
      byproductWidgets.CompletedLoadsByDestination,
      byproductWidgets.CompletedLoadsByProduct,
      byproductWidgets.CompletedLoadsByAccount,
      byproductWidgets.CreatedLoadsByDestination,
      byproductWidgets.CreatedLoadsByProduct,
      byproductWidgets.CreatedLoadsByAccount,
      byproductWidgets.LoadsByDriver,
      logsWidgets.LoadsByDriver,
      byproductOperationalWidgets.LoadsReadyForPickup,
      byproductOperationalWidgets.LoadsInTransitByDestination,
      byproductOperationalWidgets.IncompleteTickets
    ].includes(this.widget)

    this.FromAccount = [
      logsWidgets.TransferLoads,
      byproductWidgets.CompletedLoadsByDestination,
      byproductWidgets.CompletedLoadsByProduct,
      byproductWidgets.CompletedLoadsByAccount,
      byproductWidgets.CreatedLoadsByDestination,
      byproductWidgets.CreatedLoadsByProduct,
      byproductWidgets.CreatedLoadsByAccount,
      byproductWidgets.LoadsByDriver,
      byproductOperationalWidgets.LoadsReadyForPickup,
      byproductOperationalWidgets.LoadsInTransitByDestination,
      byproductOperationalWidgets.IncompleteTickets
    ].includes(this.widget)

    this.CreatedAt = [operationalWidgets.LoadsReadyForPickup, byproductOperationalWidgets.LoadsReadyForPickup].includes(this.widget)
    this.DriverAssignedAt = [operationalWidgets.LoadsReadyForPickup, byproductOperationalWidgets.LoadsReadyForPickup].includes(this.widget)

    this.Status = [
      logsWidgets.LoadsByDriver,
      byproductWidgets.LoadsByDriver
    ].includes(this.widget)

    this.TicketStatusReasons = [operationalWidgets.IncompleteTickets, byproductOperationalWidgets.IncompleteTickets].includes(this.widget)
  }
}
